import { render, staticRenderFns } from "./government.vue?vue&type=template&id=31ff797b&scoped=true&"
import script from "./government.vue?vue&type=script&lang=js&"
export * from "./government.vue?vue&type=script&lang=js&"
import style0 from "./government.vue?vue&type=style&index=0&id=31ff797b&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31ff797b",
  null
  
)

export default component.exports